import { Link } from "react-router-dom";
import { AdminService } from "../../services/AdminService";
import { useContext, useRef } from "react";
import { observer } from "mobx-react-lite";
import { storeContext } from "../../store/root-store";
import { menuPages } from "../../store/Settings";

export const Footer = observer(() => {
  const { settingsGl } = useContext(storeContext);
  const footerMenu = useRef<HTMLDivElement>(null);

  const onRouteClick = (currentRoute: menuPages) => {
    settingsGl.currentRoute = currentRoute;
  };

  return (
    <>
      {/* <div
        className="mobile-nav-margin"
        style={{
          height: footerMenu.current?.offsetHeight + "px",
        }}
      ></div> */}
      <nav
        className="mobile-nav base-page-element"
        ref={footerMenu}
        style={{
          position: "fixed",
          width: 100 + "%",
        }}
      >
        <Link
          to={"/"}
          onClick={() => {
            onRouteClick(menuPages.main);
          }}
          className={
            "bloc-icon " +
            (settingsGl.currentRoute == menuPages.main
              ? "bloc-icon-selected"
              : "")
          }
        >
          <div className="bloc-icon-img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-house"
              viewBox="0 0 16 16"
            >
              <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
            </svg>
          </div>
          <span className="block-icon-label">Главная</span>
        </Link>
        <Link
          to={"/likes"}
          onClick={() => {
            onRouteClick(menuPages.likes);
          }}
          className={
            "bloc-icon " +
            (settingsGl.currentRoute == menuPages.likes
              ? "bloc-icon-selected"
              : "")
          }
        >
          <div className="bloc-icon-img">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-info-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
            </svg> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-heart"
              viewBox="0 0 16 16"
            >
              <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
            </svg>
          </div>
          <span className="block-icon-label">Избранное</span>
        </Link>
        {/* {AdminService.getService().isAdmin() && ( */}
          <Link
            to="/about"
            onClick={() => {
              onRouteClick(menuPages.about);
            }}
            className={
              "bloc-icon " +
              (settingsGl.currentRoute == menuPages.about
                ? "bloc-icon-selected"
                : "")
            }
          >
            <div className="bloc-icon-img">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-house"
                viewBox="0 0 16 16"
              >
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />
              </svg>
            </div>
            <span className="block-icon-label">О проекте</span>
          </Link>
        {/* )} */}
        {/*<Link to="/info" className="bloc-icon">*/}
        {/*  <div className="bloc-icon-img">*/}
        {/*    <svg*/}
        {/*      xmlns="http://www.w3.org/2000/svg"*/}
        {/*      width="16"*/}
        {/*      height="16"*/}
        {/*      fill="currentColor"*/}
        {/*      className="bi bi-house"*/}
        {/*      viewBox="0 0 16 16"*/}
        {/*    >*/}
        {/*      <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5z" />*/}
        {/*    </svg>*/}
        {/*  </div>*/}
        {/*  <span className="block-icon-label">О проекте</span>*/}
        {/*</Link>*/}
      </nav>
    </>
  );
});
